const decodeProcessParameters = (params) => params.map(param => ([
  `${param.name}:${param.code}`
])).join('\n')

const encodeProcessParameters = (params, idResponse = 0) => params.split('\n').map(parameter => {
  const [name, code] = parameter.split(':')
  return ({
    idResponse: idResponse,
    name: name.trim(),
    code: code.trim()
  })
})

export default {decodeProcessParameters, encodeProcessParameters}



// WEBPACK FOOTER //
// ./src/lib/Strings.js